<template>
  <div id="Wrapper">
    <Header
      :siteInfo="siteInfo"
    />
    <div class="main_container">
      <Sidebar
        :siteInfo="siteInfo"
      />
      <HelpDetailsComponent
        v-if="siteInfo !== null && cameraInfo !== null"
        :siteInfo="siteInfo"
        :cameraInfo="cameraInfo"
        @loadFinish="loadFinish"
      />
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import HelpDetailsComponent from '../../components/help/HelpDetailsComponent'

export default {
  name: 'HelpDetails',
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    },
  },
  methods: {
    loadFinish() {
      this.$emit('loadFinish');
    },
  },
  components:{
    Header,
    Sidebar,
    HelpDetailsComponent
  },
}
</script>
<style lang="scss">
</style>